import React, { useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import '../styles.css';
import { connect, useSelector } from 'react-redux';
import { selectSize, updateStats, setOptions, setOver } from '../REDUX/actions';
import { goToPage, forceUpdate } from '../../HOME/REDUX/actions';
import { HELPED_KEY } from '../const';
import BackButton from '../COMPONENTS/BackButton';
import { Background } from '../COMPONENTS/Background';
import Logo from '../ASSETS/SymbolicaLogo.png';
import { windowSize, dbget } from '../../HOME/utils';
import { getAppInfo } from '../../HOME/info';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import { HELP_PAGE, GAME_PAGE, START_PAGE } from '../../HOME/const';
import { isNum } from '../../HOME/utils';
import * as f from '../logic';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';

const StartPage = props => {
  const { setOptions, forceUpdate } = props;
  const { sm } = useSelector(state => state);

  useEffect(() => {
    window.addEventListener('resize', forceUpdate);

    return () => {
      window.removeEventListener('resize', forceUpdate);
    };
  }, [setOptions, forceUpdate]);

  const optionAttributes = op => {
    switch (op) {
      default:
        return { gridArea: '1/1', text: '?', fontWeight: 'bold' };
      case 1:
        return { gridArea: '1/2', text: 'XS' };
      case 2:
        return { gridArea: '2/1', text: 'S' };
      case 3:
        return { gridArea: '2/2', text: 'M' };
      case 4:
        return { gridArea: '3/1', text: 'L' };
      case 5:
        return { gridArea: '3/2', text: 'XL' };
    }
  };

  const handleSize = size => {
    setSize(size);
  };

  const doHandleSize = () => {
    if (!size) {
      props.goToPage(HELP_PAGE, START_PAGE);
      return;
    }

    props.selectSize(size);

    f.getStats({ size }, stats => {
      props.updateStats(stats);
    });

    dbget(HELPED_KEY, response => {
      if (response || sm.helped) {
        props.setOver(false);
        props.goToPage(GAME_PAGE);
      } else {
        props.goToPage(HELP_PAGE, START_PAGE);
      }
    });
  };

  const { x, y } = windowSize();
  const width = Math.min(x, y) / 7;
  const appName = getAppInfo(props.app).name;
  const [size, setSize] = useState(null);

  const pulseString = useSpring({
    to: { transform: `scale(${isNum(size) ? 0.75 : 1})` },
    onRest: () => {
      if (isNum(size)) {
        doHandleSize();
      }
    },
    config: { duration: 200 },
  });

  return (
    <div className="page-root">
      <div className="ms-logo-title">
        <img src={Logo} width={width} alt="Symbolica logo" />
        <span className="sm-title" style={{ color: 'black', transform: 'translate(0.05em, 0.05em)' }}>
          {appName}
        </span>
        <span className="sm-title sm-title-gradient">{appName}</span>
      </div>
      <div className="sm-page" style={{ backgroundImage: Background }}>
        <div style={{ display: 'grid', grid: 'auto auto auto / auto auto' }}>
          {_.map([0, 1, 2, 3, 4, 5], op => {
            const { gridArea, text, fontWeight } = optionAttributes(op);
            const fontSize = op ? '40px' : '50px';
            const style = op === size ? pulseString : {};
            return (
              <animated.div
                className="sm-size-option"
                key={op}
                onClick={() => handleSize(op)}
                style={{ ...style, fontFamily: `${op ? 'Times New Roman' : 'Roboto Mono'}` }}>
                <span style={{ gridArea, color: 'black', transform: 'translate(0.05em, 0.05em)' }}>{text}</span>
                <span className="sm-title-gradient" style={{ gridArea, fontSize, fontWeight }}>
                  {text}
                </span>
              </animated.div>
            );
          })}
        </div>
        <BmgButton />
        <BackButton />
        <HomeButton />
      </div>
    </div>
  );
};

function mapStateToProps({ sm, common }) {
  return { ...sm, ...common };
}

export default connect(
  mapStateToProps,
  { selectSize, updateStats, goToPage, setOptions, setOver, forceUpdate }
)(StartPage);
